import { useState, useEffect } from "react";
import { processOrderData } from "../utils/dataProcessors";
import format from "date-fns/format";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import { endOfMonth, startOfMonth } from "date-fns";
import { endOfYear, startOfYear } from "date-fns/fp";
import api from "src/features/auth/axiosConfig";
import { DashboardData, OrderDetails, TimeRange } from "../shared/types/dashboard";

interface UseDashboardDataReturn {
  dashboardData: DashboardData | null;
  loading: boolean;
  fetchDashboardData: () => Promise<void>;
}

export const useDashboardData = (timeRange: TimeRange, customStartDate: string, customEndDate: string): UseDashboardDataReturn => {
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);

      let dateRange = { from: "", to: "" };
      const today = new Date();

      switch (timeRange) {
        case "today":
          dateRange.from = format(today, "yyyy-MM-dd");
          dateRange.to = format(today, "yyyy-MM-dd");
          break;
        case "yesterday":
          const yesterday = subDays(today, 1);
          dateRange.from = format(yesterday, "yyyy-MM-dd");
          dateRange.to = format(yesterday, "yyyy-MM-dd");
          break;
        case "week":
          dateRange.from = format(startOfWeek(today), "yyyy-MM-dd");
          dateRange.to = format(endOfWeek(today), "yyyy-MM-dd");
          break;
        case "month":
          dateRange.from = format(startOfMonth(today), "yyyy-MM-dd");
          dateRange.to = format(endOfMonth(today), "yyyy-MM-dd");
          break;
        case "year":
          dateRange.from = format(startOfYear(today), "yyyy-MM-dd");
          dateRange.to = format(endOfYear(today), "yyyy-MM-dd");
          break;
        case "custom":
          if (customStartDate && customEndDate) {
            dateRange.from = customStartDate;
            dateRange.to = customEndDate;
          }
          break;
        default:
          break;
      }

      const response = await api.get(`/app/v1/pos/order?pageNumber=1&pageSize=100000000&dateFilter=custom&startDate=${dateRange.from}&endDate=${dateRange.to}&searchBy=`);

      if (response.data && response.data.result) {
        if (response.data.result.length > 0) {
          if (response.data.result[0].Products) {
          }
        }
      }

      const allOrders: OrderDetails[] = response.data.result || [];
      const processedData = processOrderData(allOrders, timeRange, customStartDate, customEndDate);

      setDashboardData(processedData);
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboardData();
  }, [timeRange, customStartDate, customEndDate]);

  return {
    dashboardData,
    loading,
    fetchDashboardData,
  };
};
